import React, { FC, useState } from "react"
import styled from "styled-components"

import { BlockTitle, Container } from "../shared"
import { Area } from "./area"

import criminal from "../../images/law-areas/criminal.png"
import criminalBg from "../../images/law-areas/criminal-bg.png"
import civil from "../../images/law-areas/civil.svg"
import civilBg from "../../images/law-areas/criminal-bg.png"
import farm from "../../images/law-areas/farm.png"
import farmBg from "../../images/law-areas/farm-bg.png"
import monoBg from "../../images/law-areas/antimonopol-bg.png"
import corporate from "../../images/law-areas/corporative.png"
import corporateBg from "../../images/law-areas/corporative-bg.png"
import tax from "../../images/law-areas/tax.png"
import taxBg from "../../images/law-areas/tax-bg.png"
import { device } from "../../styles/media"

const AreasContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -33px;
  width: 100%;
`

const ShowMoreAreas = styled.div`
  display: flex;
  justify-content: flex-end;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 28px;
  text-align: center;
  text-decoration-line: underline;
  cursor: pointer;
`

const ContainerInner = styled.div`
  width: 100%;
  padding: 44px 120px 84px;
  @media ${device.mobileL} {
    padding: 0;
  }
`

export const Areas: FC<{
  title: string
  moreAreasTitle: string
  areasList?: { title: string; icon: string; background: string }[]
}> = ({ areasList, title, moreAreasTitle }) => {
  const [showMore, setShowMore] = useState(false)

  return (
    <Container>
      <ContainerInner>
        <BlockTitle>{title}</BlockTitle>
        <AreasContainer>
          {areasList?.map((area, index) => (
            <Area
              key={index}
              title={area.title}
              icon={area.icon}
              background={area.background}
              isShown={index <= 5 || showMore}
            />
          ))}
        </AreasContainer>
        <ShowMoreAreas onClick={() => setShowMore(!showMore)}>
          {moreAreasTitle}
        </ShowMoreAreas>
      </ContainerInner>
    </Container>
  )
}
